export default "__VITE_PUBLIC_ASSET__28934d15__"